import type { CvModelData } from '@/app/cv/types/model-data';

export const EURO5_GXZ: CvModelData = {
  href: '/product/gxz',
  label: 'GXZ',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_gxz_e92e29e81a.png',
    alt: 'GXZ',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/gxz_brochure_8d58bac2d6.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '349 แรงม้า',
    },
    {
      detail: '1,422 N-m ที่ 1,400 RPM',
    },
    {
      detail: 'GCW 50.5 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FTR_TRACTOR: CvModelData = {
  href: '/product/ftr-tractor',
  label: 'FTR TRACTOR',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_ftr_tractor_dc9b8c0ab4.png',
    alt: 'FTR TRACTOR',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.isuzu-tis.com/ftr_tractor_brochure_509bfabdc0.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '240 แรงม้า',
    },
    {
      detail: '706 N-m ที่ 1,450 RPM',
    },
    {
      detail: 'GCW 35 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FYH: CvModelData = {
  href: '/product/fyh',
  label: 'FYH',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_fyh_ea729909bf.png',
    alt: 'FYH',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/fyh_brochure_77ec7e03ee.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '349 แรงม้า',
    },
    {
      detail: '1,422 N-m ที่ 1,400 RPM', //cvdf
    },
    {
      detail: 'GVW 30 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FXZ: CvModelData = {
  href: '/product/fxz',
  label: 'FXZ',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_fxz_8c0a0a743f.png',
    alt: 'FXZ',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/fxz_brochure_7298fe254f.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '349 แรงม้า',
    },
    {
      detail: '1,422 N-m ที่ 1,400 RPM',
    },
    {
      detail: 'GVW 25 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FVZ: CvModelData = {
  href: '/product/fvz',
  label: 'FVZ',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_fvz_75efb640cd.png',
    alt: 'FVZ',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/fvz_brochure_538a5e7bf4.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '240 แรงม้า',
    },
    {
      detail: '706 N-m ที่ 1,450 RPM',
    },
    {
      detail: 'GVW 25 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FVZ_S: CvModelData = {
  href: '/product/fvz',
  label: 'FVZ-S',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_fvz_s_ee890e3653.png',
    alt: 'FVZ-S',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/fvz_brochure_538a5e7bf4.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '280 แรงม้า',
    },
    {
      detail: '820 N-m ที่ 1,450 RPM',
    },
    {
      detail: 'GVW 25 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FVM: CvModelData = {
  href: '/product/fvm',
  label: 'FVM',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_fvm_4bc2270650.png',
    alt: 'FVM',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/fvm_series_02c8be5312.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '240 แรงม้า',
    },
    {
      detail: '706 N-m ที่ 1,450 RPM',
    },
    {
      detail: 'GVW 25 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FVM_S: CvModelData = {
  href: '/product/fvm',
  label: 'FVM-S',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_fvm_s_b660dab5bd.png',
    alt: 'FVM-S',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/fvm_series_02c8be5312.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '280 แรงม้า',
    },
    {
      detail: '820 N-m ที่ 1,450 RPM',
    },
    {
      detail: 'GVW 25 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FTR: CvModelData = {
  href: '/product/ftr',
  label: 'FTR',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_ftr_dc1b583166.png',
    alt: 'FTR',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/ftr_brochure_b939dd687b.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '240 แรงม้า',
    },
    {
      detail: '706 N-m ที่ 1,450 RPM',
    },
    {
      detail: 'GVW 15 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FRR: CvModelData = {
  href: '/product/frr',
  label: 'FRR',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_frr_a1fd3258e0.png',
    alt: 'FRR',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/frr_series_fc7f8305f9.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '190 แรงม้า',
    },
    {
      detail: '513 N-m ที่ 1,600 - 2,600 RPM',
    },
    {
      detail: 'GVW 9.9 - 10.4 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_FRR_S: CvModelData = {
  href: '/product/frr',
  label: 'FRR-S',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_frr_s_fb522a5556.png',
    alt: 'FRR-S',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/frr_s_brochure_9184f28a03.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '203 แรงม้า',
    },
    {
      detail: '637 N-m ที่ 1,600 RPM',
    },
    {
      detail: 'GVW 9.9 - 10.4 ตัน',
    },
    {
      detail: 'DPD',
    },
  ],
};

export const EURO5_NQR: CvModelData = {
  href: '/product/nqr',
  label: 'NQR',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_nqr_2ccbdd8b75.png',
    alt: 'NQR',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/nqr_brochure_4f63d00f57.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '154 แรงม้า',
    },
    {
      detail: '419 N-m ที่ 1,600 - 2,600 RPM',
    },
    {
      detail: 'GVW 9.5 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_NPR: CvModelData = {
  href: '/product/npr',
  label: 'NPR',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_npr_9398efbaa7.png',
    alt: 'NPR',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/npr_brochure_6714d9927c.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '154 แรงม้า',
    },
    {
      detail: '419 N-m ที่ 1,600 - 2,600 RPM',
    },
    {
      detail: 'GVW 8.5 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_NMR: CvModelData = {
  href: '/product/nmr',
  label: 'NMR',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_nmr_616b61a698.png',
    alt: 'NMR',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/nmr_brochure_803fcdb02d.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '123 แรงม้า',
    },
    {
      detail: '354 N-m ที่ 1,500 RPM',
    },
    {
      detail: 'GVW 6.5 - 7.4 ตัน',
    },
    {
      detail: 'DOC with POC',
    },
  ],
};

export const EURO5_NLR: CvModelData = {
  href: '/product/nlr',
  label: 'NLR',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_nlr_a07f3b1a5c.png',
    alt: 'NLR',
    width: 1600,
    height: 1200,
  },
  brochureHref: 'https://assets.isuzu-tis.com/nlr_brochure_514832b053.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '123 แรงม้า',
    },
    {
      detail: '354 N-m ที่ 1,500 RPM',
    },
    {
      detail: 'GVW 4.4 ตัน',
    },
    {
      detail: 'DOC with POC',
    },
  ],
};

export const EURO5_FRR_MIXER: CvModelData = {
  href: '/product/frr',
  label: 'FRR Mixer',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_frr_mixer_a3a7dcb1b7.png',
    alt: 'FRR Mixer',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.isuzu-tis.com/frr_mixer_brochure_380837cb85.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '190 แรงม้า',
    },
    {
      detail: '513 N-m ที่ 1,600 - 2,600 RPM',
    },
    {
      detail: 'GVW 9.9 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_NMR_MIXER: CvModelData = {
  href: '/product/nmr',
  label: 'NMR Mixer',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_nmr_mixer_636e0469de.png',
    alt: 'NMR Mixer',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.isuzu-tis.com/nmr_mixer_brochure_b2bf51b2cc.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '123 แรงม้า',
    },
    {
      detail: '354 N-m ที่ 1,500 RPM',
    },
    {
      detail: 'GVW 8 ตัน',
    },
    {
      detail: 'DOC with POC',
    },
  ],
};

export const EURO5_FXZ_MIXER: CvModelData = {
  href: '/product/fxz',
  label: 'FXZ Mixer',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_fxz_mixer_f1da99e990.png',
    alt: 'FXZ Mixer',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.isuzu-tis.com/fxz_mixer_brochure_c5ccee9462.pdf',
  engineType: 'euro-5',
  features: [
    {
      detail: '349 แรงม้า',
    },
    {
      detail: '1,422 N-m ที่ 1,400 RPM',
    },
    {
      detail: 'GVW 25 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};

export const EURO5_NPR_MINI_BUS: CvModelData = {
  href: '/product/npr-minibus-chassis',
  label: 'NPR MINI BUS CHASSIS',
  image: {
    src: 'https://assets.isuzu-tis.com/euro_5_npr_mini_bus_466b56db7b.png',
    alt: 'NPR MINI BUS CHASSIS',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.isuzu-tis.com/npr_minibus_brochure_1ae8b78e79.pdf',
  features: [
    {
      detail: '154 แรงม้า',
    },
    {
      detail: '419 N-m ที่ 1,600 - 2,600 RPM',
    },
    {
      detail: 'GVW 7.5 ตัน',
    },
    {
      detail: 'DOC',
    },
  ],
};
